import { Dispatch, SetStateAction } from "react";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InfoCircle } from "react-bootstrap-icons";

import { NMEAQualityCode } from "../types";

interface QualitySelectorProps {
  minQuality: NMEAQualityCode;
  setMinQuality: Dispatch<SetStateAction<NMEAQualityCode>>;
}

const QUALITY_CHOICES = [
  NMEAQualityCode.GPS,
  NMEAQualityCode.DGPS,
  NMEAQualityCode.RTK_FLOAT,
];

// To avoid user confusion, we don't differentiate between RTK float and
// fixed. When the user sees "RTK" in the dropdown, it means that RTK float
// or better is required.
export const QualityChoiceName: Record<NMEAQualityCode, string> = {
  [NMEAQualityCode.NO_FIX]: "No Fix",
  [NMEAQualityCode.GPS]: "GPS",
  [NMEAQualityCode.DGPS]: "DGPS",
  [NMEAQualityCode.RTK_FLOAT]: "RTK",
  [NMEAQualityCode.RTK_FIXED]: "RTK",
};

export default function QualitySelector({
  minQuality,
  setMinQuality,
}: QualitySelectorProps) {
  return (
    <Form.Group as={Row}>
      <OverlayTrigger
        overlay={
          <Tooltip id="tooltip-quality">
            Scanner status and trajectory will be shown as red if the location
            quality is not at least this level
          </Tooltip>
        }
      >
        <Form.Label column="sm" className="text-nowrap" size="sm">
          Location quality <InfoCircle />
        </Form.Label>
      </OverlayTrigger>
      <Col>
        <Form.Select
          size="sm"
          value={minQuality}
          onChange={(e) => setMinQuality(Number(e.target.value))}
        >
          {QUALITY_CHOICES.map((value) => (
            <option key={value} value={value}>
              {QualityChoiceName[value]}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  );
}
